// extracted by mini-css-extract-plugin
module.exports = {"textField":"TextField_textField__2bRQO","shrink":"TextField_shrink__2r473"};